import "./styles.scss";

import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";

const SimpleArticleCard = ({ url, image, icon, title, description, aside }) => {
  const Type = url ? Link : "div";

  return (
    <Type className="simple-article-card" to={url}>
      {(image || icon) && (
        <div className="simple-article-card__thumbnail">
          <div className="simple-article-card__thumbnail-inner">
            <img src={image ?? icon} alt={title} />
          </div>
        </div>
      )}
      <div className="simple-article-card__body">
        <div className="simple-article-card__body__header">
          <h3>{title}</h3>
        </div>
        {(image || icon) && description && (
          <div
            className={clsx(
              "simple-article-card__body__description",
              !!aside && "simple-article-card__body__description--aside"
            )}
          >
            {!!aside && <small>{aside}</small>}
          </div>
        )}
      </div>
    </Type>
  );
};

export default SimpleArticleCard;
